import {
  PlusCircleOutlined,
  EditOutlined,
  FileImageOutlined,
  TrophyOutlined,
  PlusOutlined,
  InfoCircleOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import {
  Button,
  Col,
  Form,
  Input,
  Modal,
  Row,
  Select,
  TreeSelect,
  DatePicker,
  InputNumber,
  message,
  Divider,
  Switch,
  Space,
  Alert,
  Typography,
  Upload,
  Image,
  Tooltip,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import dayjs from "dayjs";
import { resolveImageUrl } from "../../../utils/image";
import {
  getListDataGift,
  getListTelcoDataGift,
} from "../../../api/giftExchange/dataGift";
import {
  getListGiftExchange,
  updateGiftExchange,
  updateImageGiftExchange,
} from "../../../api/giftExchange/giftExchange";

import { store } from "../../../redux/configStore";
import { transformData } from "../../../utils/recursive";
import useStoreData from "../../../hooks/useStoreData";
import { getListServiceProduct } from "../../../api/pointPromotion/serviceProduct";
import { debounce } from "lodash";
import ProductSelectorModal from "./components/ProductSelectorModal";
import ProductForm from "../Product/components/ProductForm";
import { categoryAPIWithErrorHandling } from "../../../api/product/category";
import FormShell from "../../../components/common/FormShell";
import { neutral, brand, semantic, spacing, radius, typography, border } from "../../../theme/tokens";

const { Text } = Typography;

const sectionTitle = {
  fontSize: typography.size.md,
  fontWeight: typography.weight.semibold,
  color: neutral[900],
  marginBottom: spacing[5],
  letterSpacing: "-0.005em",
};

export default function EditGiftExchangeTable({
  isModalOpen,
  currentPage,
  pageSize,
  handleOk,
  handleCancel,
  record,
  asPage = false,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [form] = Form.useForm();
  const [branchId, setBranchId] = useState(record?.mcoupon_branch_id || null);
  const [isActive, setIsActive] = useState(record?.status === 1 ? true : false);
  const [unlimited, setUnlimited] = useState(
    record?.unlimited === 1 ? true : false
  );
  const [giftType, setGiftType] = useState(record?.type || "PRODUCT");
  const dispatch = useDispatch();
  const [selectedTelco, setSelectedTelco] = useState(
    record?.datas?.[0]?.telco || null
  );

  const [fileList, setFileList] = useState([]);
  const [isImageUpdating, setIsImageUpdating] = useState(false);
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");
  const [productQuantities, setProductQuantities] = useState({}); // { productId: quantity }
  const [isSelectorOpen, setIsSelectorOpen] = useState(false);
  const [selectedProductDetails, setSelectedProductDetails] = useState([]);
  const [isInventoryCheck, setIsInventoryCheck] = useState(record?.is_inventory_check !== false);
  const [categories, setCategories] = useState([]);
  const [isQuickAddOpen, setIsQuickAddOpen] = useState(false);
  const isReadOnly = record?.point_histories_count > 0;

  useEffect(() => {
    if (record?.image && isModalOpen) {
      setFileList([
        {
          uid: "-1",
          name: "Hình ảnh hiện tại",
          status: "done",
          url: resolveImageUrl(record.image),
        },
      ]);
    } else {
      setFileList([]);
    }
  }, [record, isModalOpen]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await categoryAPIWithErrorHandling.getList({ per_page: 100 });
        if (res.success) {
          setCategories(res.data.data || []);
        }
      } catch (error) {
        console.error("Lỗi khi tải danh mục");
      }
    };
    fetchCategories();
  }, []);

  const searchTerm = useRef(""); // Giữ giá trị search hiện tại
  const [serviceProducts, setServiceProducts] = useState(
    record?.products || []
  ); // Danh sách sản phẩm
  const [productPage, setProductPage] = useState(1); // Trang hiện tại
  const [isProductLoading, setIsProductLoading] = useState(false);
  const [hasMoreProducts, setHasMoreProducts] = useState(true); // Còn dữ liệu để load không

  const { data: allListStore, loading: isLoadStoreAll } = useStoreData();
  const { listTelcoDataGifts } = useSelector(
    (state) => state.persistedReducer.telcoDataGiftSlice
  );
  const { listDataGifts } = useSelector(
    (state) => state.persistedReducer.dataGiftSlice
  );

  const storeOptions = transformData(allListStore?.data)?.filter(
    (item) => item.parent_id === 0
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        const requests = [];
        requests.push(
          store.dispatch(
            getListTelcoDataGift({ currentPage: 1, pageSize: 100 })
          )
        );
        await Promise.all(requests);
      } catch (error) {
        message.error("Không thể tải dữ liệu!");
      }
    };
    fetchData();
  }, [branchId]);

  useEffect(() => {
    if (selectedTelco) {
      store.dispatch(
        getListDataGift({ currentPage: 1, pageSize: 100, telco: selectedTelco })
      );
    }
  }, [selectedTelco]);

  useEffect(() => {
    if (record?.items && giftType === "PRODUCT") {
      const selectedProducts = record.items.map(
        (item) => item.service_product_id
      );
      form.setFieldsValue({ products: selectedProducts }); // Đặt giá trị mặc định

      // Đồng bộ thông tin chi tiết sản phẩm cũ
      const detailInfo = record.items.map(item => item.service_product).filter(Boolean);
      setSelectedProductDetails(detailInfo);
    }
  }, [record, form, giftType]);

  useEffect(() => {
    if (record?.items && giftType === "DATA") {
      form.setFieldsValue({
        telco: record.items[0].telco,
        data_pack: record.items[0].data_pack,
      });
    }
  }, [record, form, giftType]);

  const SelectedTelcoChange = (value) => {
    setSelectedTelco(value);
    form.setFieldsValue({ data_pack: null });
  };

  const handleFormSubmit = async (values) => {
    setIsLoading(true);
    // ✅ Validation thủ công cho sản phẩm
    if (giftType === "PRODUCT" && (!selectedProductDetails || selectedProductDetails.length === 0)) {
        message.error("Vui lòng chọn ít nhất một sản phẩm!");
        setIsLoading(false);
        return;
    }

    const updatedData = {
      ...values,
      start_date: values.start_date.format("YYYY-MM-DD HH:mm:ss"),
      end_date: values.end_date.format("YYYY-MM-DD HH:mm:ss"),
      status: isActive,
      unlimited: unlimited ? 1 : 0,
      datas: [{ telco: values.telco, data_pack: values.data_pack }],
      products: selectedProductDetails.map(product => ({
        id: product.id,
        quantity: productQuantities[product.id] || 1
      })),
      is_inventory_check: isInventoryCheck
    };
    try {
      const response = await dispatch(
        updateGiftExchange({ id: record.id, data: updatedData })
      );
      if (updateGiftExchange.fulfilled.match(response)) {
        message.success("Cập nhập thành công");
        await dispatch(getListGiftExchange({ currentPage, pageSize }));
        handleOk();
      } else if (updateGiftExchange.rejected.match(response)) {
        if (response.payload.errors) {
          Object.keys(response.payload.errors).forEach((field) => {
            const errorMessages = response.payload.errors[field];
            errorMessages.forEach((errorMessage) => {
              message.error(`${errorMessage}`);
            });
          });
        } else if (response.payload.error) {
          message.error(response.payload.error);
        }
        if (response.payload.message) {
          message.error(response.payload.message);
        }
      }
    } catch (err) {
      console.error("Có lỗi xảy ra:", err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (branchId) {
      setServiceProducts([]); // Xóa dữ liệu cũ khi đổi đơn vị
      setProductPage(1);
      setHasMoreProducts(true);
      fetchServiceProducts(1); // Tải trang đầu tiên
    }
  }, [branchId]);

  const handleSearch = debounce((value) => {
    searchTerm.current = value.trim();
    setProductPage(1);
    setServiceProducts([]);
    setHasMoreProducts(true);

    fetchServiceProducts(1, value.trim());
  }, 600);

  const handleScroll = (e) => {
    if (
      e.target.scrollTop + e.target.offsetHeight >=
      e.target.scrollHeight - 10
    ) {
      if (!isProductLoading && hasMoreProducts) {
        fetchServiceProducts(productPage + 1, searchTerm.current);
      }
    }
  };

  const fetchServiceProducts = async (
    page = 1,
    search = searchTerm.current
  ) => {
    if (!branchId) return;
    setIsProductLoading(true);

    try {
      const response = await store.dispatch(
        getListServiceProduct({
          currentPage: page,
          pageSize: 20,
          branchId,
          search,
        })
      );

      if (response.payload.data.length > 0) {
        if (search !== undefined && search !== null && search !== "") {
          setServiceProducts([]);
          setHasMoreProducts(true);
          setServiceProducts(response.payload.data);
          setProductPage(1);
        } else {
          setServiceProducts((prev) =>
            page === 1
              ? response.payload.data
              : [...prev, ...response.payload.data]
          );

          setProductPage(page);
        }
      } else {
        setHasMoreProducts(false);
      }
    } catch (error) {
      message.error("Lỗi khi tải danh sách sản phẩm!");
    } finally {
      setIsProductLoading(false);
    }
  };

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewVisible(true);
    setPreviewTitle(file.name || "Xem trước hình ảnh");
  };

  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const handleChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
  };

  const beforeUpload = (file) => {
    const isImage = file.type.startsWith("image/");
    if (!isImage) {
      message.error("Giao diện: Chỉ chấp nhận file hình ảnh!");
      return Upload.LIST_IGNORE;
    }
    return false; // Manual upload
  };

  useEffect(() => {
    if (isModalOpen && record) {
      // Khởi tạo số lượng từ items cũ
      if (record.items && Array.isArray(record.items)) {
        const qtys = {};
        record.items.forEach(item => {
          qtys[item.service_product_id] = item.quantity || 1;
        });
        setProductQuantities(qtys);
      }
    }
  }, [record, isModalOpen]);

  const handleUpdateImage = async () => {
    if (!fileList.length || !fileList[0].originFileObj) {
      message.warning("Vui lòng chọn ảnh mới trước khi cập nhật!");
      return;
    }

    setIsImageUpdating(true);
    const formData = new FormData();
    formData.append("image", fileList[0].originFileObj);

    try {
      const response = await dispatch(updateImageGiftExchange({ id: record.id, data: formData }));
      if (updateImageGiftExchange.fulfilled.match(response)) {
        message.success("Cập nhật hình ảnh thành công!");
        await dispatch(getListGiftExchange({ currentPage, pageSize }));
      }
    } catch (err) {
      message.error("Lỗi khi cập nhật ảnh!");
    } finally {
      setIsImageUpdating(false);
    }
  };

  const uploadButton = (
    <div>
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>Thay đổi</div>
    </div>
  );

  return (
    <FormShell
      asPage={asPage}
      title={
        <div style={{ display: "flex", alignItems: "center", gap: spacing[2] }}>
          <EditOutlined style={{ fontSize: 18, color: brand.primary }} />
          <span style={{ fontSize: typography.size.lg, fontWeight: typography.weight.semibold, color: neutral[900] }}>
            Chỉnh sửa chương trình quà tặng
          </span>
        </div>
      }
      open={isModalOpen}
      footer={[
        <Button key="cancel" onClick={handleCancel} style={{ minWidth: 100 }}>
          Hủy
        </Button>,
        !isReadOnly && (
          <Button
            key="submit"
            type="primary"
            icon={<EditOutlined />}
            loading={isLoading}
            onClick={() => form.submit()}
            style={{ minWidth: 140 }}
          >
            Lưu thay đổi
          </Button>
        ),
      ]}
      onCancel={handleCancel}
      width="70%"
      styles={{
        body: {
          padding: spacing[6],
          maxHeight: "calc(100vh - 120px)",
          overflow: "auto",
        },
        header: {
          borderBottom: border.hairline,
          paddingBottom: spacing[4],
          marginBottom: 0,
        },
      }}
    >
      {isReadOnly && (
        <Alert
          message="Chương trình đã có lượt đổi thưởng"
          description={`Chương trình này đã có ${record.point_histories_count} lượt khách hàng đổi quà. Để đảm bảo tính chính xác của lịch sử dữ liệu, bạn không thể chỉnh sửa thông tin này.`}
          type="warning"
          showIcon
          style={{ marginBottom: spacing[5], borderRadius: radius.base }}
        />
      )}
      <Form
        form={form}
        layout="vertical"
        onFinish={handleFormSubmit}
        requiredMark={false}
        disabled={isReadOnly}
        initialValues={{
          mcoupon_branch_id: record?.mcoupon_branch_id,
          name: record?.name,
          point: record?.point,
          stock: record?.stock,
          type: record?.type,
          products: record?.items?.map(it => it.service_product_id),
          telco: record?.items?.[0]?.telco,
          data_pack: record?.items?.[0]?.data_pack,
          start_date: record?.start_date ? dayjs(record.start_date) : null,
          end_date: record?.end_date ? dayjs(record.end_date) : null,
          unlimited: record?.unlimited === 1,
          status: record?.status === 1,
          is_inventory_check: record?.is_inventory_check !== false
        }}
      >
        {/* Section 1: Thông tin cơ bản & Hình ảnh */}
        <div style={sectionTitle}>Thông tin cơ bản & Hình ảnh</div>
        <Row gutter={[spacing[6], spacing[4]]} align="top">
          <Col xs={24} md={8}>
            <Form.Item label="Hình ảnh chương trình" style={{ textAlign: "center", marginBottom: 0 }}>
              <Upload
                listType="picture-card"
                fileList={fileList}
                onPreview={handlePreview}
                onChange={handleChange}
                beforeUpload={beforeUpload}
                maxCount={1}
                accept="image/*"
                className="upload-list-centered"
                disabled={isReadOnly}
              >
                {fileList.length >= 1 ? null : uploadButton}
              </Upload>
              {fileList.length > 0 && fileList[0].originFileObj && !isReadOnly && (
                <Button
                  size="small"
                  type="primary"
                  ghost
                  onClick={handleUpdateImage}
                  loading={isImageUpdating}
                  icon={<FileImageOutlined />}
                  style={{ marginTop: 8 }}
                >
                  Cập nhật ảnh mới
                </Button>
              )}
            </Form.Item>
          </Col>

          <Col xs={24} md={16}>
            <Space direction="vertical" style={{ width: "100%" }} size={spacing[4]}>
              <Form.Item
                label="Tên quà tặng"
                name="name"
                style={{ marginBottom: 0 }}
                rules={[{ required: true, message: "Vui lòng nhập tên quà tặng!" }]}
              >
                <Input placeholder="Tên chương trình..." />
              </Form.Item>

              <Form.Item
                label="Đơn vị quản lý"
                name="mcoupon_branch_id"
                style={{ marginBottom: 0 }}
                rules={[{ required: true, message: "Vui lòng chọn đơn vị!" }]}
              >
                <TreeSelect
                  allowClear
                  showSearch
                  treeData={storeOptions}
                  placeholder="Chọn đơn vị"
                  loading={isLoadStoreAll}
                  filterTreeNode={(input, node) => (node.title || "").toLowerCase().includes(input.toLowerCase())}
                  onChange={(value) => setBranchId(value)}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Space>
          </Col>
        </Row>

        <Divider style={{ margin: `${spacing[6]}px 0` }} />

        {/* Section 2: Phân loại & Nội dung */}
        <div style={sectionTitle}>Phân loại & Nội dung</div>
        <Row gutter={[spacing[4], spacing[4]]}>
          <Col span={24}>
            <Form.Item label="Loại quà tặng" name="type" style={{ marginBottom: 0 }}>
              <Select disabled>
                <Select.Option value="PRODUCT">Sản phẩm (Vật lý/Dịch vụ)</Select.Option>
                <Select.Option value="DATA">Dữ liệu (Thẻ cào/Data)</Select.Option>
              </Select>
            </Form.Item>
          </Col>

          {giftType === "PRODUCT" && (
            <Col span={24}>
              <Form.Item
                label="Sản phẩm áp dụng"
                required
                help="Nhấn nút bên dưới để điều chỉnh danh sách sản phẩm."
                style={{ marginBottom: 0 }}
              >
                <div style={{ display: "flex", flexDirection: "column", gap: spacing[3] }}>
                  <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: spacing[3] }}>
                    <Tooltip title={!branchId ? "Vui lòng chọn Đơn vị quản lý trước" : ""}>
                      <Button
                        icon={<PlusOutlined />}
                        onClick={() => setIsSelectorOpen(true)}
                        style={{ width: "fit-content" }}
                        disabled={!branchId || isReadOnly}
                      >
                        Quản lý sản phẩm
                      </Button>
                    </Tooltip>

                    {!isReadOnly && (
                      <Tooltip title={!branchId ? "Vui lòng chọn Đơn vị quản lý trước" : ""}>
                        <Button
                          type="dashed"
                          icon={<PlusCircleOutlined />}
                          onClick={() => setIsQuickAddOpen(true)}
                          style={{ width: "fit-content" }}
                          disabled={!branchId || isReadOnly}
                        >
                          Thêm mới sản phẩm
                        </Button>
                      </Tooltip>
                    )}

                    {!isReadOnly && (
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <Divider type="vertical" style={{ height: 32 }} />
                        <Space size={spacing[1]}>
                          <Text style={{ fontSize: typography.size.base, color: neutral[700] }}>Kiểm soát kho:</Text>
                          <Form.Item name="is_inventory_check" valuePropName="checked" noStyle>
                            <Switch checked={isInventoryCheck} onChange={setIsInventoryCheck} size="small" />
                          </Form.Item>
                        </Space>
                      </div>
                    )}
                  </div>

                  {selectedProductDetails.length > 0 && (
                    <div style={{ background: neutral[50], padding: spacing[4], borderRadius: radius.md, border: border.hairline }}>
                      <Text style={{ fontSize: typography.size.base, color: neutral[500], marginBottom: spacing[3], display: "block" }}>
                        <InfoCircleOutlined /> Sản phẩm đã chọn ({selectedProductDetails.length}):
                      </Text>
                      <Row gutter={[spacing[3], spacing[3]]}>
                        {selectedProductDetails.map((product) => (
                          <Col span={24} key={product.id}>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                background: neutral[0],
                                padding: `${spacing[2]}px ${spacing[4]}px`,
                                borderRadius: radius.base,
                                border: border.hairline,
                              }}
                            >
                              <Space size="middle" style={{ flex: 1 }}>
                                {product.image && (
                                  <Image
                                    src={resolveImageUrl(product.image)}
                                    width={40}
                                    height={40}
                                    className="rounded object-cover"
                                    preview={false}
                                  />
                                )}
                                <div style={{ display: "flex", flexDirection: "column" }}>
                                  <Text style={{ fontSize: typography.size.base, fontWeight: typography.weight.medium, color: neutral[900] }}>{product.name}</Text>
                                  <Text style={{ fontSize: typography.size.xs, color: neutral[500] }}>{product.code} | Còn lại: {product.remain_stock}</Text>
                                </div>
                              </Space>

                              <Space>
                                <Text style={{ fontSize: typography.size.sm, color: neutral[500] }}>Số lượng trong suất:</Text>
                                <InputNumber
                                  min={1}
                                  size="small"
                                  value={productQuantities[product.id] || 1}
                                  onChange={(val) => setProductQuantities((prev) => ({ ...prev, [product.id]: val }))}
                                  style={{ width: 65 }}
                                  disabled={isReadOnly}
                                />
                                <Button
                                  type="text"
                                  danger
                                  size="small"
                                  icon={<DeleteOutlined />}
                                  disabled={isReadOnly}
                                  onClick={() => {
                                    const newDetails = selectedProductDetails.filter((p) => p.id !== product.id);
                                    setSelectedProductDetails(newDetails);
                                    form.setFieldsValue({ products: newDetails.map((p) => p.id) });
                                    setProductQuantities((prev) => {
                                      const next = { ...prev };
                                      delete next[product.id];
                                      return next;
                                    });
                                  }}
                                />
                              </Space>
                            </div>
                          </Col>
                        ))}
                      </Row>
                    </div>
                  )}
                </div>
              </Form.Item>

              <ProductSelectorModal
                open={isSelectorOpen}
                onCancel={() => setIsSelectorOpen(false)}
                branchId={branchId}
                selectedIds={form.getFieldValue("products") || []}
                onSelect={(rows, keys) => {
                  setSelectedProductDetails(rows);
                  form.setFieldsValue({ products: keys });
                  setProductQuantities((prev) => {
                    const next = { ...prev };
                    keys.forEach((id) => {
                      if (!next[id]) next[id] = 1;
                    });
                    return next;
                  });
                }}
              />

              <ProductForm
                open={isQuickAddOpen}
                onCancel={() => setIsQuickAddOpen(false)}
                branchId={branchId}
                categories={categories}
                onSuccess={(newProduct) => {
                  setIsQuickAddOpen(false);
                  if (newProduct && newProduct.id) {
                    setSelectedProductDetails((prev) => {
                      if (!prev.find((p) => p.id === newProduct.id)) {
                        return [...prev, newProduct];
                      }
                      return prev;
                    });
                    const currentProducts = form.getFieldValue("products") || [];
                    if (!currentProducts.includes(newProduct.id)) {
                      form.setFieldsValue({ products: [...currentProducts, newProduct.id] });
                    }
                    setProductQuantities((prev) => ({ ...prev, [newProduct.id]: 1 }));
                    message.success(`Đã tự động thêm sản phẩm: ${newProduct.name}`);
                  }
                }}
              />
            </Col>
          )}

          {giftType === "DATA" && (
            <>
              <Col xs={24} md={12}>
                <Form.Item
                  label="Nhà mạng"
                  name="telco"
                  style={{ marginBottom: 0 }}
                  rules={[{ required: true, message: "Vui lòng chọn nhà mạng!" }]}
                >
                  <Select
                    placeholder="Chọn nhà mạng"
                    options={listTelcoDataGifts?.map((telco) => ({
                      label: telco.name,
                      value: telco.key,
                    }))}
                    onChange={SelectedTelcoChange}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  label="Gói cước"
                  name="data_pack"
                  style={{ marginBottom: 0 }}
                  rules={[{ required: true, message: "Vui lòng chọn gói!" }]}
                >
                  <Select
                    placeholder="Chọn gói"
                    options={
                      selectedTelco
                        ? listDataGifts?.map((data) => ({
                            label: data.package_name,
                            value: data.data_pack,
                          }))
                        : []
                    }
                    disabled={!selectedTelco}
                  />
                </Form.Item>
              </Col>
            </>
          )}
        </Row>

        <Divider style={{ margin: `${spacing[6]}px 0` }} />

        {/* Section 3: Điều kiện, Hạn mức & Trạng thái */}
        <div style={sectionTitle}>Điều kiện, Hạn mức & Trạng thái</div>
        <Row gutter={[spacing[4], spacing[4]]}>
          <Col xs={24} md={12}>
            <Form.Item
              label="Điểm quy đổi"
              name="point"
              style={{ marginBottom: 0 }}
              rules={[{ required: true, message: "Vui lòng nhập điểm!" }]}
            >
              <Input type="number" prefix={<TrophyOutlined style={{ color: semantic.warning }} />} suffix="điểm" />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              label="Hạn mức kho"
              name="stock"
              style={{ marginBottom: 0 }}
              rules={[{ required: true, message: "Vui lòng nhập hạn mức!" }]}
            >
              <Input type="number" suffix="quà" />
            </Form.Item>
          </Col>

          <Col xs={24} md={12}>
            <Form.Item
              label="Bắt đầu"
              name="start_date"
              style={{ marginBottom: 0 }}
              rules={[{ required: true, message: "Vui lòng chọn ngày!" }]}
            >
              <DatePicker showTime style={{ width: "100%" }} format="DD/MM/YYYY HH:mm" />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              label="Kết thúc"
              name="end_date"
              style={{ marginBottom: 0 }}
              rules={[{ required: true, message: "Vui lòng chọn ngày!" }]}
            >
              <DatePicker showTime style={{ width: "100%" }} format="DD/MM/YYYY HH:mm" />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Row gutter={[spacing[3], spacing[3]]}>
              <Col xs={24} md={12}>
                <div style={{ border: border.hairline, borderRadius: radius.base, background: neutral[50], padding: `${spacing[3]}px ${spacing[4]}px` }}>
                  <Row justify="space-between" align="middle">
                    <Col><Text style={{ fontWeight: typography.weight.medium, color: neutral[800] }}>Giới hạn lượt</Text></Col>
                    <Col>
                      <Form.Item name="unlimited" valuePropName="checked" noStyle>
                        <Switch checked={unlimited} onChange={setUnlimited} disabled={isReadOnly} />
                      </Form.Item>
                    </Col>
                  </Row>
                </div>
              </Col>
              <Col xs={24} md={12}>
                <div style={{ border: border.hairline, borderRadius: radius.base, background: neutral[50], padding: `${spacing[3]}px ${spacing[4]}px` }}>
                  <Row justify="space-between" align="middle">
                    <Col><Text style={{ fontWeight: typography.weight.medium, color: neutral[800] }}>Kích hoạt</Text></Col>
                    <Col>
                      <Form.Item name="status" valuePropName="checked" noStyle>
                        <Switch checked={isActive} onChange={setIsActive} disabled={isReadOnly} />
                      </Form.Item>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Form>

      <Modal
        open={previewVisible}
        title={previewTitle}
        footer={null}
        onCancel={() => setPreviewVisible(false)}
      >
        <img alt="preview" style={{ width: "100%" }} src={previewImage} />
      </Modal>

      <style jsx>{`
        .upload-list-centered .ant-upload-select-picture-card {
          margin: 0 auto !important;
        }
      `}</style>
    </FormShell>
  );
}
